import { render, staticRenderFns } from "./CPDipendentiPremi.vue?vue&type=template&id=dab97eea"
import script from "./CPDipendentiPremi.vue?vue&type=script&lang=js"
export * from "./CPDipendentiPremi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports